import { types } from 'mobx-state-tree';

const SingleNotification = types
  .model('singleNotification', {
    id: types.number,
    name: types.string,
    topBar: types.boolean,
    email: types.boolean,
    phone: types.boolean,
    sort: types.number,
  })
  .views(self => ({
    get getId() {
      return self.id;
    },
  }))
  .actions(self => {
    const setValue = (key, bool) => {
      self[key] = bool;
    };

    return {
      setValue,
    };
  });

export default SingleNotification;
